<template>
  <div class="nutritional-section">
    <details>
      <summary>Nutritional information</summary>
      <div class="calorie-toggle">
        <label class="calorie-toggle">Calories / Kilojoules:</label>
        <ToggleSwitch :on-label="'Calories'" :off-label="'KiloJoules'" :modelValue="cals" :modelName="'unitType'" @update:modelValue="handleUnitSelection" />
      </div>
      <div class="nutritional-categories">
        <div class="cat">
          <label for="calories"
            >Energy ({{ cals ? "Calories" : "KiloJoules" }}):<span v-if="energy" class="conversion"> = {{ cals ? kilojoules : calories }}</span></label
          >
          <input type="text" id="calories" v-model="energy" @change="saveNutritionalInfo" />
        </div>
        <div class="cat">
          <label for="protein">Protein (g):</label>
          <input type="text" id="protein" v-model="protein" @change="saveNutritionalInfo" />
        </div>
        <div class="cat">
          <label for="fat_total">Fat, total (g):</label>
          <input type="text" id="fat_total" v-model="fat_total" @change="saveNutritionalInfo" />
        </div>
        <div class="cat">
          <label for="saturated_fat">Saturated fat (g):</label>
          <input type="text" id="saturated_fat" v-model="saturated_fat" @change="saveNutritionalInfo" />
        </div>
        <div class="cat">
          <label for="carbohydrates">Carbohydrates (g):</label>
          <input type="text" id="carbohydrates" v-model="carbohydrates" @change="saveNutritionalInfo" />
        </div>
        <div class="cat">
          <label for="sugars">Sugars (g):</label>
          <input type="text" id="sugars" v-model="sugars" @change="saveNutritionalInfo" />
        </div>
        <div class="cat">
          <label for="sodium">Sodium (mg):</label>
          <input type="text" id="sodium" v-model="sodium" @change="saveNutritionalInfo" />
        </div>
      </div>
    </details>
  </div>
</template>
<script>
import ToggleSwitch from "./ToggleSwitch.vue";
export default {
  name: "NutritionalInformation",
  components: {
    ToggleSwitch,
  },

  props: {
    nutritionalInfo: {
      type: Object,
      required: false,
    },
  },

  mounted() {
    if (this.nutritionalInfo) {
      this.energy = this.nutritionalInfo.energy_calories ? parseFloat(this.nutritionalInfo.energy_calories) : null;
      this.protein = this.nutritionalInfo.protein ? parseFloat(this.nutritionalInfo.protein) : null;
      this.fat_total = this.nutritionalInfo.fat_total ? parseFloat(this.nutritionalInfo.fat_total) : null;
      this.saturated_fat = this.nutritionalInfo.saturated_fat ? parseFloat(this.nutritionalInfo.saturated_fat) : null;
      this.carbohydrates = this.nutritionalInfo.carbohydrates ? parseFloat(this.nutritionalInfo.carbohydrates) : null;
      this.sugars = this.nutritionalInfo.sugars ? parseFloat(this.nutritionalInfo.sugars) : null;
      this.sodium = this.nutritionalInfo.sodium ? parseFloat(this.nutritionalInfo.sodium) : null;
    }
  },

  data() {
    return {
      energy: null,
      protein: null,
      fat_total: null,
      saturated_fat: null,
      carbohydrates: null,
      sugars: null,
      sodium: null,
      cals: true,
    };
  },

  computed: {
    calories() {
      if (!this.energy) return null;
      const val = this.cals ? parseFloat(this.energy) : Math.round(parseFloat(this.energy) / 4.184);
      return `${val} Calories`;
    },
    kilojoules() {
      if (!this.energy) return null;
      const val = this.cals ? Math.round(parseFloat(this.energy) * 4.184) : parseFloat(this.energy);
      return `${val} kJ`;
    },
  },

  methods: {
    handleUnitSelection(value) {
      this.cals = value;
    },

    saveNutritionalInfo() {
      let nutritionalInfo = {
        energy_calories: this.calories,
        energy_kilojoules: this.kilojoules,
        protein: this.protein ? `${this.protein} g` : null,
        fat_total: this.fat_total ? `${this.fat_total} g` : null,
        saturated_fat: this.saturated_fat ? `${this.saturated_fat} g` : null,
        carbohydrates: this.carbohydrates ? `${this.carbohydrates} g` : null,
        sugars: this.sugars ? `${this.sugars} g` : null,
        sodium: this.sodium ? `${this.sodium} mg` : null,
      };
      this.$emit("updateNutritionalInfo", nutritionalInfo);
    },
  },
};
</script>
<style lang="scss">
.nutritional-section {
  background-color: var(--primary-colour);
  border-radius: 0.5rem;
  padding: 0.5rem;
  margin: 0.5rem;

  details {
    box-sizing: border-box;
    .calorie-toggle {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      margin-bottom: 1rem;
      label {
        font-weight: bold;
      }
    }

    .nutritional-categories {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
      gap: 0.5rem;
      .cat {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: var(--secondary-colour);
        border-radius: 0.5rem;
        padding: 0.75rem 0.5rem;
        label {
          font-weight: bold;
          text-wrap: wrap;
          .conversion {
            font-weight: normal;
            font-size: 0.75rem;
            opacity: 0.7;
            display: block;
          }
        }
        input {
          border-radius: 0.25rem;
          margin: 0 !important;
          width: 4rem;
        }
      }
    }
  }
}
</style>
